import { render, staticRenderFns } from "./CInput.vue?vue&type=template&id=3a985424&scoped=true&"
import script from "./CInput.vue?vue&type=script&lang=ts&"
export * from "./CInput.vue?vue&type=script&lang=ts&"
import style0 from "./CInput.vue?vue&type=style&index=0&id=3a985424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a985424",
  null
  
)

export default component.exports